import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20cream%20and%20amber%20gradient%20background%20with%20soft%20geometric%20shapes%2C%20minimalist%20modern%20digital%20platform%20atmosphere%2C%20gentle%20light%20beams%2C%20clean%20elegant%20composition%2C%20subtle%20texture%2C%20no%20text%2C%20peaceful%20and%20professional%20mood&width=1800&height=900&seq=jm-hero-bg-01&orientation=landscape"
        alt="jm天堂官方入口背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/5 to-black/20"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center space-x-2 bg-background-50/90 backdrop-blur-sm rounded-full px-4 py-2 mb-8 border border-background-200/50">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-foreground-700 font-medium">官方认证入口 · 2026年8月已更新</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          jm天堂
          <span className="block text-lg md:text-2xl lg:text-3xl font-normal mt-3 text-background-200">
            官方入口与完整使用指南
          </span>
        </h1>

        <p className="text-background-200/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          jm天堂是深受用户喜爱的内容平台，本页为您提供官方入口、最新地址、使用教程及常见问题解答，帮助您快速访问jm天堂，畅享丰富内容资源。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/tutorial"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line mr-2 text-lg"></i>
            查看使用教程
          </Link>
          <Link
            to="/category/faq"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-base hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-answer-line mr-2 text-lg"></i>
            常见问题解答
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center space-x-8 text-background-200/60 text-sm">
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-line text-base text-accent-400"></i>
            <span>安全可靠</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-refresh-line text-base text-accent-400"></i>
            <span>实时更新</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-user-heart-line text-base text-accent-400"></i>
            <span>用心服务</span>
          </div>
        </div>
      </div>
    </section>
  );
}